import React, { Fragment } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cube";

// import required modules
import { EffectCube, Autoplay, EffectCards } from "swiper/modules";
import NewHomePortfolioComponent from "./NewHomePortfolioComponent";
export default function MoreProjectsPortfolio() {
  return (
    <>
      <Swiper
        className="mySwiper"
        effect={"cards"}
        grabCursor={true}
        modules={[EffectCards, Autoplay]}
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        speed={1500}
      >
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="image-pos-right more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="#FCF1F2"
            title="Al-Wajeeh - Hybrid Application Development"
            titleClass="new-portfolio-title"
            borderColor="rgb(234, 245, 255)"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            sectionOneTextOne="4.5"
            sectionOneTextTwo="Average Rating"
            imgSrc="SMBLMockup.png"
            sectionTextColor="cl3CBBA5"
            linkTitle="backendlogo5.png, frontendlogo1.png,CloudService1.png,twilio.png,database2.png,pusher.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={true}
            portfolioBtnColor={"#2A2B26"}
            cardClass="left-portfolio-card"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/hybrid-application-development-for-al-wajeeh"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="transparent"
            title="Berger's Table Pads - Custom-made Table Pads Online"
            titleClass="new-portfolio-title"
            borderColor="rgb(234, 245, 255)"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            sectionOneTextOne="100+"
            sectionOneTextTwo="Daily Online Orders"
            sectionTwoTextOne="Top 3"
            sectionTwoTextTwo="SEO Ranking"
            imgSrc="Mockup_6 3.png"
            sectionTextColor="cl3CBBA5"
            linkTitle="frontendlogo1.png, backendlogo1.png,database1.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#2A2B26"}
            cardClass="p-md-5 newportpadding"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/hybrid-application-development-for-al-wajeeh"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="image-pos-right more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="#FCF1F2"
            title="TreatMe - Doctor at your Fingertip"
            titleClass="new-portfolio-title"
            borderColor="#00671c"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            sectionOneTextOne="100K+"
            sectionOneTextTwo="App Booked"
            sectionTwoTextOne="4.5"
            sectionTwoTextTwo="Average Rating"
            imgSrc="appDevImage1.png"
            sectionTextColor="clB60117"
            linkTitle="react-native.svg, backendlogo1.png, database2.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#F64646"}
            cardClass="left-portfolio-card"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="max80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/ecommerce-website-development-for-my-pet-carnivore"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="transparent"
            title="Walletier - Payments Made Easy"
            titleClass="new-portfolio-title"
            borderColor="rgb(234, 245, 255)"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            sectionOneTextOne="100K+"
            sectionOneTextTwo="Daily Transactions"
            sectionTwoTextOne="15+"
            sectionTwoTextTwo="Payment Options"
            imgSrc="WalletierImg.png"
            sectionTextColor="cl3CBBA5"
            linkTitle="react-native.svg, backendlogo5.png,payment-gateway.svg"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#2A2B26"}
            cardClass="p-md-5 newportpadding"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/hybrid-application-development-for-al-wajeeh"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="image-pos-right more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="#FCF1F2"
            title="Gocoworq - Marketplace for Coworking"
            titleClass="new-portfolio-title"
            borderColor="rgb(234, 245, 255)"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            sectionOneTextOne="10K+"
            sectionOneTextTwo="Daily Searches"
            sectionTwoTextOne="100+"
            sectionTwoTextTwo="Daily Inquires"
            imgSrc="portfolio2.webp"
            sectionTextColor="cl3CBBA5"
            linkTitle="backendlogo5.png, frontendlogo2.png,database2.png,frontendlogo7.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#2A2B26"}
            cardClass="p-md-5 newportpadding"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/hybrid-application-development-for-al-wajeeh"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="transparent"
            title="BoxScore - Real Time Feedback"
            titleClass="new-portfolio-title"
            borderColor="#00671c"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            // sectionOneTextOne="20K+"
            // sectionOneTextTwo="Downloads"
            // sectionTwoTextOne="100K+"
            // sectionTwoTextTwo="Tour Package Bookings"
            imgSrc="portfolioCardImg9.png"
            sectionTextColor="clB60117"
            linkTitle="backendlogo4.png, frontendlogo7.png, database2.png, jquery-mpc.svg,google-map.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#F64646"}
            cardClass="left-portfolio-card"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="max80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/ecommerce-website-development-for-my-pet-carnivore"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="image-pos-right more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="#FCF1F2"
            title="Talevation - Hiring Assessment"
            titleClass="new-portfolio-title"
            borderColor="rgb(234, 245, 255)"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            // sectionOneTextOne="10K+"
            // sectionOneTextTwo="Daily Searches"
            // sectionTwoTextOne="100+"
            // sectionTwoTextTwo="Daily Inquires"
            imgSrc="newPortfolioCardImg10.png"
            sectionTextColor="cl3CBBA5"
            linkTitle="wordpress.png, database2.png,mobile6.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#2A2B26"}
            cardClass="p-md-5 newportpadding"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/hybrid-application-development-for-al-wajeeh"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition=" more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="transparent"
            title="Tulamama - Maternity Goods"
            titleClass="new-portfolio-title"
            borderColor="#00671c"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            // sectionOneTextOne="20K+"
            // sectionOneTextTwo="Downloads"
            // sectionTwoTextOne="100K+"
            // sectionTwoTextTwo="Tour Package Bookings"
            imgSrc="newPortfolioCardImg11.png"
            sectionTextColor="clB60117"
            linkTitle="wordpress.png, cms1.png,mobile6.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#F64646"}
            cardClass="left-portfolio-card"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="max80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/ecommerce-website-development-for-my-pet-carnivore"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="image-pos-right more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="#FCF1F2"
            title="SecureRoofing - Roof Fitting Company ERP"
            titleClass="new-portfolio-title"
            borderColor="rgb(234, 245, 255)"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            // sectionOneTextOne="10K+"
            // sectionOneTextTwo="Daily Searches"
            // sectionTwoTextOne="100+"
            // sectionTwoTextTwo="Daily Inquires"
            imgSrc="newPortfolioCardImg12.png"
            sectionTextColor="cl3CBBA5"
            linkTitle="backendlogo1.png, jquery-mpc.svg, database1.png  "
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#2A2B26"}
            cardClass="p-md-5 newportpadding"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber="/portfolio/hybrid-application-development-for-al-wajeeh"
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="transparent"
            title=" MarketWagon - Local Food Delivered"
            titleClass="new-portfolio-title"
            borderColor="#00671c"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            sectionOneTextOne="1M+"
            sectionOneTextTwo="Orders Delivered"
            sectionTwoTextOne="4.5"
            sectionTwoTextTwo="Average Rating"
            imgSrc="portfolio1.webp"
            sectionTextColor="clB60117"
            linkTitle="frontendlogo2.png, backendlogo5.png, database2.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#F64646"}
            cardClass="left-portfolio-card"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="max80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber=""
          />
        </SwiperSlide>
        <SwiperSlide>
          <NewHomePortfolioComponent
            ImagePosition="image-pos-right more-project-portfolio-card mx-0"
            mainClass=""
            PortfolioCardBGC="#FCF1F2"
            title="Telloss - Cold Logistics Software"
            titleClass="new-portfolio-title"
            borderColor="rgb(234, 245, 255)"
            customSectionCol="col-lg-8 col-md-8 col-12"
            customSection1Col="col-lg-6 col-md-6 col-6"
            customSection2Col="col-lg-6 col-md-6 col-6"
            customSection2ColPadding="1.8rem"
            sectionOneTextOne="500+"
            sectionOneTextTwo="Orders Fulfilled"
            // sectionTwoTextOne="100+"
            // sectionTwoTextTwo="Daily Inquires"
            imgSrc="telloss.webp"
            sectionTextColor="cl3CBBA5"
            linkTitle="frontendlogo5.png, frontendlogo6.png, mobile6.png, frontendlogo7.png, jquery-mpc.svg, backendlogo5.png, database2.png, sendgrid.svg, fedex.png, UPS.png, CPanel.png"
            TitleCustomClasses="fontColorBlue"
            portfolioBtn={false}
            portfolioBtnColor={"#2A2B26"}
            cardClass="p-md-5 newportpadding"
            IndustryServingsHoverCompimgSrc="images/Vector (2).png"
            IndustryServingsHoverComphoverImg="images/LearnMoreGreenFullIcon.png"
            customLineHeight="45px"
            customMarginImg="maxwid-80 py-lg-0 py-md-0 py-4"
            IsRedirectToSamePage="yes"
            redirectNumber=""
          />
        </SwiperSlide>
      </Swiper>
    </>
  );
}
